import Slide from '@/mixins/Slide'
import Graph from './Graph'
import Resize from '@/mixins/Resize'

export default
{
    mixins: [
        Slide,
        Resize
    ],

    components:
    {
        Graph
    },

    data()
    {
        return {
            current: -1,
            paragraphsHeight: 0
        }
    },

    computed:
    {
        content()
        {
            return this.$store.slide11
        }
    },

    created()
    {
        this.canClose = false
    },

    mounted()
    {
        this.testParagraphsSize()
    },

    methods:
    {
        select(num)
        {
            this.current = num

            this.canClose = false

            window.requestAnimationFrame(() =>
            {
                this.canClose = true
            })
        },

        close()
        {
            if(this.canClose)
            {
                this.current = - 1
            }
        },

        onResized()
        {
            this.testParagraphsSize()
        },

        testParagraphsSize()
        {
            this.paragraphsHeight = this.$refs.paragraph
                .map(el => el.offsetHeight)
                .reduce((max, current) => Math.max(max, current))
        }
    }
}
